export const GET_TABLE_DATA = 'GET_TABLE_DATA'
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA'
export const CLEAR_PAYMENT_DATA = 'CLEAR_PAYMENT_DATA'
